import React from 'react'

import { videos } from '../video-list.json'

const ListView = () => {
    const videoList = [].concat(...videos).map((a) => 
    <li>
        <span style={
            {
                textDecoration: (a.url ? "line-through" : "")
            }
        }
        >
            {a.title}
        </span>: { a.comment || a.comments }
    </li>);

    return (
        <div>
            { videoList }
        </div>
    )
}

export default ListView
